import styled from 'styled-components'

import { CSS_ELEMENTS_RESETS } from '../../styles'

const Styled = styled.button`
  ${CSS_ELEMENTS_RESETS.button};
  opacity: 1;
`

export default Styled
